module.exports = __webpack_public_path__ + "static/img/lab-report.8f9c192e.png";